import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[set-color]' })
export class SetColorDirective implements AfterViewInit {
 
  @Input() backgroundColor: string;
 
  constructor(private hostElement: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.hostElement.nativeElement.style.backgroundColor = this.backgroundColor;
    this.hostElement.nativeElement.style.color = this.getCorrectTextColor(this.backgroundColor || this.hostElement.nativeElement.style.backgroundColor);
  }

  getCorrectTextColor(color){
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast
    
    Color brightness is determined by the following formula: 
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000
    
    I know this could be more compact, but I think this is easier to read/explain.
    
    */
    const threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */
    
    const rgb = hexToRgb(getColor(color));

    if (rgb.length === 3){
      return (((((rgb[0] * 299) + (rgb[1] * 587) + (rgb[2] * 114)) / 1000)) > threshold) ? '#000000' : '#ffffff';
    }
    else{
      return '#000000';
    }

    function getColor(c: string){
      const ctx = document.createElement('canvas').getContext('2d');
      ctx.fillStyle = c;
      return ctx.fillStyle;
    } 
    function hexToRgb(h){
      return h.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
        .substring(1).match(/.{2}/g)
        .map((x) => parseInt(x, 16));
    }
  }
}
